"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _DevTools = _interopRequireDefault(require("../utils/DevTools"));

var _events = require("events");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/*
  TODO (Hubert, 2019B): Simplify the behavior according to notes in Meristem
*/
var FormStore = /*#__PURE__*/function (_EventEmitter) {
  _inherits(FormStore, _EventEmitter);

  var _super = _createSuper(FormStore);

  function FormStore() {
    var _this;

    _classCallCheck(this, FormStore);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.subscriber = function (key) {
      return {
        subscribe: function subscribe(cb) {
          return _this.addListener(key, cb);
        },
        unsubscribe: function unsubscribe(cb) {
          return _this.removeListener(key, cb);
        }
      };
    };

    _this.items = {};

    _this.get = function (key) {
      return _this.items[key];
    };

    _this.insert = function (key, state) {
      _this.items[key] = state;

      _this.emit(key);
    };

    _this.insertIfEmpty = function (key, state) {
      if (_this.items[key] !== undefined) {
        return;
      }

      _this.insert(key, state);
    };

    _this.update = function (key, change) {
      // Note (Hubert, 2018D): We're not using _.assign as the keys can be nested
      _lodash["default"].each(change, function (v, k) {
        _lodash["default"].set(_this.items[key], k, v);
      });

      _this.emit(key);
    };

    _this.updateSheet = function (key, change) {
      // Note (Hubert, 2018D): We're not using _.assign as the keys can be nested
      _lodash["default"].each(change, function (v, k) {
        _this.items[key].set(k, v);
      });

      _this.emit(key);
    };

    _this.remove = function (key) {
      delete _this.items[key];

      _this.emit(key);
    };

    return _this;
  }

  return FormStore;
}(_events.EventEmitter);

var instance = new FormStore();

_DevTools["default"].expose({
  FormStore: instance
});

var _default = instance;
exports["default"] = _default;